import { Text } from '@medly-components/core';
import styled from 'styled-components';

export const ContentText = styled(Text)`
    text-align: center;
    padding: 0 2rem;
`;

export const ContentBoldText = styled(Text).attrs({ textWeight: 'Medium' })`
    color: ${({ theme }) => theme.font.defaults.color};
    display: inline;
`;
